<template>
  <div class="mask" @click="clickHandler">
    <img :src="imageMap.shareArrow" alt="" class="arrow" :style="arrowStyle">
    <div class="text" v-if="!isMiniProgram">
      点击右上角更多
      <br>
      分享给好友或到朋友圈
    </div>
    <div class="text" v-if="isMiniProgram">
      点击右上角「…」分享给好友
    </div>
  </div>
</template>

<script>
  import imageMap from '../../image-map.js';
  import env      from '@/utils/env.js';

  export default {
    data() {
      return { imageMap };
    },

    computed : {
      isMiniProgram() {
        return env.isWeixinMiniProgram;
      },

      arrowStyle() {
        return this.isMiniProgram ? {
          marginRight : '60px'
        } : {
          marginRight : '20px'
        };
      }
    },

    methods : {
      clickHandler() {
        this.$emit( 'clickShareLayer' );
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./share-layer.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/home/share-layer.vue